
  export const common = {
    请求延时: '請求延時',
    操作成功: '操作成功',
    暂无数据: '暫無數據',
    请输入: '請輸入',
    copyok: '複制成功',
    copyerror: '複制失败',
  };
  // header: {},
  // footer: {},

  export const tableList = {
    '跟单交易量':'跟單交易量',
    '跟单总交易量':'跟單總交易量',
    用户昵称: "使用者暱稱",
    持仓: '持倉',
    仓位: '倉位',
    当前委托: '當前委託',
    当前计划: '當前計劃',
    历史仓位: '歷史倉位',
    账单: '財務記錄',
    全部平仓: '全部平倉',
    全部撤单: '全部撤單',

    合约名称: '合約名稱',
    创建时间: '創建時間',
    方向: '方向',
    杠杆: '槓桿',
    保证金: '保證金',
    开仓价格: '開倉價格',
    开仓均价: '開倉均價',
    全仓风险率: '全倉風險率',
    预估爆仓价: '預估暴倉價',
    收益率: '收益率',
    平仓价格: '平倉價格',
    预计强平价: '預計強平價',
    持仓数量: '持仓数量',
    张: '張',
    风险率: '風險率',
    保证金率: '保證金率',
    预计止盈价: '預計止盈價',
    预计止损价: '預計止損價',
    浮动盈亏: '浮動盈虧',
    平仓盈亏: '平倉盈虧',
    盈亏: '盈虧',
    委托数量: '委託數量',
    委托价格: '委託價格',
    成交价格: '成交價格',
    成交均价: '成交均價',
    止盈价: '止盈價',
    止损价: '止損價',
    执行价: '執行價',
    触发条件: '觸發條件',
    操作: '操作',
    手续费: '手續費',
    平仓类型: '平倉類型',
    类型: '類型',
    数量: '數量',

    逐仓做多: '逐倉做多',
    逐仓做空: '逐倉做空',
    全仓做多: '全倉做多',
    全仓做空: '全倉做空',
    永续合约: '永續合約',

    手动平仓: '手動平倉',
    市价平仓: '市價平倉',
    限价平仓: '限價平倉',
    止盈: '止盈',
    止损: '止損',
    手动撤销: '手動撤銷',
    自动减仓: '自動減倉',
    强制减仓: '強制減倉',
    强制平仓: '強制平倉',
    资金不足系统撤单: '資金不足系統撤單',
    资金超限系统撤单: '資金超限系統撤單',
    撤单: '撤單',
    平仓: '平倉',
    更多: '更多',
    部分平仓: '部分平倉',
    反向开仓: '反向開倉',
    加仓: '加倉',
    一键平仓: '一鍵平倉',
    最新价: '最新價',
    体验金平仓: '24小時平倉',
    下单时间: '下單時間',
    交易类型: '交易類型',
    委托类型: '委托類型',
    成交类型: '成交類型',
    逐仓平多: '逐倉平多',
    逐仓开多: '逐倉開多',
    逐仓平空: '逐倉平空',
    逐仓开空: '逐倉開空',
    全仓平多: '全倉平多',
    全仓开多: '全倉開多',
    全仓平空: '全倉平空',
    全仓开空: '全倉開空',
    可平量为0: '可平量0',
    激活价格: '激活價格',
    状态: '狀態',
    未激活: '未激活',
    已激活: '已激活',
    回调率: '回調率',
    仓位ID: '倉位ID',
  };
  export const dialog = {
    前往设置: '前往設置',
    提示: '提示',
    确定: '確 定',
    取消: '取 消',
    确认要全部平仓吗: '請確認是否要以市價全部平倉，且撤銷所有委托單?',
    确认要全部撤单吗: '確認要全部撤單嗎？',
    确认要一键平仓吗: '確認要一鍵平倉嗎？',
    确认要一键平仓: '確認要一鍵平倉，與解除跟踪單關係?',
    确认要市价平仓吗: '確認要市價平倉嗎？',
    确认要限价平仓吗: '確認要限價平倉嗎？',
    需先设置总跟单账户:"需先設置總跟單賬戶，才能開啟跟單",
    需全部平仓后可重新设置:"持有跟單倉位時無法修改跟單金額及倍率，需全部平倉後可重新設置",
    加仓: '加倉',
    不能为空: '不能爲空',
    必须为数字值: '必須爲數字值',
    数字不能小于等于0: '數位不能小於等於0',
    请输入正确的杠杆倍数: '請輸入正確的杠杆倍數',
    无法切换仓位模式: '無法切換倉位模式',
    当前账户没有权限: '當前帳戶沒有許可權',
    swap001: '當前有持倉，無法切換倉位模式',

    按张数: '按張數',
    按金额: '按金額',
    按比例: '按比例',
    按价格: '按價格',
    张: '張',
    预计加仓金额: '預計加倉金額',
    预计加仓张数: '預計加倉張數',
    持仓数量: '持倉數量',
    开仓价格: '開倉價格',
    确认要反向开仓吗: '確認要反向開倉嗎？',
    预计平仓金额: '預計平倉金額',
    预计平仓比例: '預計平倉比例',
    预计平仓张数: '預計平倉張數',
    比例不可以大于: '比例不可以大於',
    比例不可以小于: '比例不可以小於',
    部分平仓: '部分平倉',
    确认撤单吗: '確認撤單嗎？',
    确认要平仓吗: '確認要平倉嗎？',
    盈亏: '盈虧',
    当前止损价: '當前止損價',
    预估止损价: '預估止損價',
    亏损: '虧損',
    止损修改: '止損修改',
    止损比例: '止損比例',
    止损价格: '止損價格',
    当前盈利价: '當前盈利價',
    预估止盈价: '預估止盈價',
    收益: '收益',
    止盈修改: '止盈修改',
    止盈比例: '止盈比例',
    止盈价格: '止盈價格',
    请输入加仓数: '請輸入加倉數',
    请输入金额: '請輸入金額',
    请输入止盈价格: '請輸入止盈價格',
    请输入止盈比例: '請輸入止盈比例',
    请输入止损价格: '請輸入止損價格',
    请输入止损比例: '請輸入止損比例',

    'BTC/USDT账户模式': 'BTC/USDT賬戶模式',
    账户模式: '賬戶模式',
    调整仓位模式: '調整倉位模式',
    保证金模式: '保證金模式',
    仓位模式: '倉位模式',
    调整保证金模式: '調整保證金模式對USDT所有合約生效',
    调整仓位合并模式: '調整倉位合并模式對USDT所有合約生效',
    全仓模式: '全倉模式',
    仓位合并: '倉位合并',
    逐仓: '逐倉',
    全仓: '全倉',
    合仓: '合倉',
    分仓: '分倉',
    swap002:
      '逐倉模式下，用戶可雙向持倉，空頭倉位與多頭倉位風險獨立計算。用戶爆倉只會損失倉位保證金，用戶主動平倉時，空頭倉位與多頭倉位分別產生的虧損級盈利，會立即結算到對應倉位的倉位保證金中。',
    全仓模式下所有仓位将共享合约账户的可用保证金:
      '全倉模式下所有倉位將共享合約賬戶的可用保證金，若發生強平，可能損失所有倉位和可用保證金。請注意持倉風險！',
    合仓提示: '',
    分仓提示: '',
    不再提示: '不再提示',

    biking合约用户使用协议: 'biking合約用戶使用協議',
    综述:
      '<b>1.綜述</b><br><br>' +
      '<span>' +
      '1.1永續合約(“本服務”)是“biking”推出的虛擬資產衍生品。由“biking”負責產品的設計管理和交易平台的運營服務。' +
      '爲使用“biking”永續合約，您應當閱讀並遵守《“biking”永續合約用戶使用協議》(“本協議”)。請您務必審慎閱讀、充分理解各條款內容，並選擇接受或不接受本協議。' +
      '<br><br>' +
      '1.2除非您已閱讀並接受本協議所有條款，否則您無權使用“biking”永續合約及其相應的服務。您接受本協議的行爲，以及您使用本服務的行爲即視爲您已閱讀並同意本協議的約束。' +
      '</span>' +
      '<br><br>' +
      '<b>2. 使用本服務的資格</b>' +
      '<br><br>' +
      '<span>2.1 您了解並確認：' +
      '<br>' +
      '您已同意遵守“biking服務條款”，同時您有資格並且不被禁止使用其中定義的“服務”;' +
      '<br>' +
      '本協議與您所在國家或地區的法律沒有衝突;' +
      '<br>' +
      '您是存入本服務的虛擬資產的合法所有者，並保證這些虛擬資產的來源是合法的。' +
      '<br><br>' +
      '2.2您了解使用本服務的風險，包括但不限於：' +
      '<br>' +
      '虛擬資產及其衍生品的高價格波動可能會在短時間內造成重大或全部損失；' +
      '</span>',
    我已阅读并同意上述协议: '我已閱讀並同意上述協議',

    调整杠杆: '調整槓桿',
    杠杆倍数: '槓桿倍數',
    当前杠杆倍数最大可开: '當前槓桿倍數最大可開：',
    '当前仓位所需保证金：': '當前倉位所需保證金：',

    交易单位切换: '交易單位切換',
    成交类型切换: '成交類型切換',
    限价: '限價',
    市价: '市價',
    数字范围必须在: '數字範圍必須在 1 到 100 之間',
    请输入平仓数: '請輸入平倉數',
    请输入平仓比例: '請輸入平倉比例',
    请输入整数: '請輸入整數',
    以当前最优价格交易: '以當前最優價格交易',
    请输入格式正确的杠杆倍数: '请输入格式正确的杠杆倍数',
    杠杆倍数提示: '當前杠桿倍數較高，請注意風險。',
    下单二次确认: '下單二次確認',
    平仓二次确认: '平倉二次確認',
    下单确认: '下單確認',
    二次确认不展示: '不再展示(您可在“偏好設置”中重新啓動)',
    切换交易单位: '切换交易单位',
    偏好设置: '偏好設置',
    仓位止盈止损: '倉位止盈止損',
    移动止盈止损: '移動止盈止損',
    止盈止损提示:
      '移動止盈止損用於倉位平倉，指的是當前行情網利好的方向推進，爲了保障交易者的收益，當前行情在回調的情況下，將交易者設定好的維托提交至市場的策略委托。當市場的最新價格到達設置的激活價格時，訂單被激活；當市場價格到達交易者設定該策略后最高（最低）價格的（1±回調幅度）后，記會觸發維托成交，執行價格為最高（最低）價格的（1±回調幅度）。',
    最新成交价: '最新成交價',
    设置止盈: '設置止盈',
    设置止损: '設置止損',
    预计盈利: '預計盈利',
    预计亏损: '預計虧損',
    调整保证金: '調整保證金',
    增加: '增加',
    减少: '減少',
    最大: '最大',
    当前仓位保证金: '當前倉位保證金',
    最大可增加: '最大可增加',
    最大可减少: '最大可減少',
    调整后参考强评价: '調整後參考強平價',
    请输入保证金: '請輸入保證金',
    强平价格: '强平價格',
    开仓数量: '開倉數量',
    计算: '計算',
    计算结果: '計算結果僅供參考',
    回调率: '回調率',
    请输入回调率: '請輸入回調率',
    仓位数量: '倉位數量',
    激活价: '激活價',
    请输入激活价: '請輸入激活價',
    激活做多提示: '做多方向需高於最新成交價',
    激活做空提示: '做空方向需低於最新成交價',
  };
  export const codeInfo = {
    永续合约: '永續',
    标记价格: '標記價格',
    指数价格: '指數價格',
    指数价格提示:
      '該合約的實時指數價格。此價格將參與用戶持倉的預估爆倉價格，可能與合約最新成交價格有所偏差，以避免價格操縱',
    '24H最高': '24H最高',
    '24H最低': '24H最低',
    资金费率: '當前資金費率',
    距费用结算: `距離本期費用結算還有`,
    我的赠金: '我的贈金',
  };
  export const panKou = {
    交易深度: '盤口',
    实时成交: '買賣盤',
    张: '張',
    保证金: '保證金',
    价格: '價格',
    数量: '數量',
    时间: '時間',
    累计: '累計',
  };
  export const placeOrder = {
    立即去玩:"すぐに始める",
    全仓: '全倉',
    逐仓: '逐倉',
    杠杆: '槓桿',
    开多: '開多',
    开空: '開空',
    市价委托: '市價委託',
    限价委托: '限價委託',
    计划委托: '計劃委託',
    价格: '價格',
    数量: '數量',
    限价: '限價',
    市价: '市價',
    止盈止损: '止盈止損',
    张: '張',
    开仓价: '開倉價',
    触发价: '觸發價',
    执行价: '執行價',

    收益: '收益',
    按比例设置: '按比例設置',
    按价格设置: '按價格設置',
    亏损: '虧損',

    swap003: '買入/做多',
    swap004: '賣出/做空',
    做多: '做多',
    做空: '做空',
    买入: '買入',
    卖出: '賣出',
    可用: '可用',
    可做多: '可做多',
    可做空: '可做空',

    资产: '資產',
    持仓保证金: '持倉保證金',
    未实现盈亏: '未實現盈虧',
    净值: '淨值',
    可用保证金: '可用保證金',
    账户余额: '帳戶餘額',
    风险率: '風險率',

    合约信息: '合約信息',
    指数来源: '指數來源',
    合约面值: '合約面值',
    资金费率: '資金費率',
    最大杠杆: '最大槓桿',
    下单方向可开张数的: '下單方向可開張數的',

    立即注册: '註冊',
    登录: '登陸',
    swap005: '資產(永續合約)',
    登录以查看: '登陸以查看',

    请输入价格: '請輸入價格',
    请输入数量: '請輸入數量',
    请输入限价: '請輸入限價',
    请输入止盈止损: '請輸入止盈止損',
    '止损率不能大于90%': '止損率不能大於90%',
    止损价格不能大于: '止損價格不能大於',
    开通合约账号: '開通合約賬號',
    账号冻结: '賬號凍結',
    '止盈率不能大于1000%': '止盈率不能大於1000%',
    请输入触发价: '請輸入觸發價',
    保证金: '保證金',
    体验金: '體驗金',
    不使用体验金: '不使用體驗金',
    查看详情: '查看詳情',
    委托保证金: '委托保證金',
    币: '幣',
    计算器: '計算器',
    划转: '劃轉'
  };
  export const codelist = {
    搜索: '搜索',
    全部: '全部',
    交易对: '交易對',
    最新价: '最新價',
    涨幅: '漲幅',
    自选: '自選',
    添加自选成功: '添加自選',
    取消自选成功: '取消自選',
  };
  export const merchandiser = {
    我的实盘: "我的實盤",
    与优秀的交易员共同赚钱:"與優秀的交易員共同賺錢",
    code_00051: "跟單社區",
    个人中心:'個人中心',
    更多服务:'更多服务',
    钱包: "錢包",
    衍生品:'衍生品',
    跟单设置:'跟單設置',
    跟单: '跟單',
    跟单提示: '數據每小時更新一次',
    我的跟单: '我的跟單',
    成为交易员: '成為交易員',
    综合排名: '綜合排名',
    收益率: '收益率',
    累计收益率: '累計收益率',
    近3周收益: '近3周收益',
    近3周胜率: '近3周勝率',
    总收益: '總收益',
    累计跟随人数: '累計跟隨人數',
    AUM: 'AUM',
    当前跟谁: '當前跟隨',
    搜索交易员: '搜索交易員',
    满员: '滿員',
    申请成为交易员: '申請成爲交易員',
    手机号: '手機號',
    邮箱: '郵箱',
    请输入邮箱: '請輸入郵箱',
    邮箱错误: '請輸入正確郵箱',
    请输入手机号: '請輸入手機號',
    手机号错误: '請輸入正確手機號',
    请输入正确数值: '請輸入正確金額',
    申请交易员提示文案: '申請成爲交易員帶單，即可獲取帶單利潤分成',
    跟单确认: "跟單確認",
    我已同意跟单协议: '我已閱讀並同意跟單協定',
    跟单协议: '《跟單協定》',
    申请跟单提示文案: "本協定由您（以下稱為“您”或“您的”）和幣王訂立。 您訪問、使用或幣王平臺或其下任何一家網站（wang.com）、移動應用程序提供的任何服務或者以下第4款進一步描述的、幣王或其下任何一家隸屬機构的網站提供的其他相關服務（以下統稱為“本服務”），即表示您確認已經閱讀、 理解並接受本使用條款協定（以下簡稱為“本使用條款”）規定的所有條款和條件，以及我們在平臺公佈的隱私權聲明。 此外，在使用本服務的部分功能時，您可能還需遵守適用於這些功能的附加條款和條件。",
    申请跟单提示文案1: "1.跟隨交易員開單，有可能存在虧損風險。 該風險由跟單用戶自行承擔；",
    申请跟单提示文案2: "2.幣王平臺支持跟隨者使用逐倉模式跟單帳戶進行跟單，跟隨者如需自主開倉可前往合約使用合約帳戶進行合約交易，該期間跟單帳戶不受影響。",
    申请跟单提示文案3: "3.跟隨成功後，只對交易員新開倉的倉位進行跟隨，已經持有的倉位不跟隨； 您可隨時取消跟單，取消跟單不會對已跟隨的訂單進行平倉，您可選擇手動平倉；",
    申请跟单提示文案4: "4.跟單期間，對跟單倉位進行調整將導致您脫離跟單模式；",
    申请跟单提示文案5: "5.跟隨交易員平倉後產生盈利，該訂單將分12%的盈利金額給帶單交易員作為獎勵。",
    申请跟单提示文案6: "6.跟隨交易員下單，可能存在虧損風險，請謹慎選擇，並注意風險控制並瞭解跟單風險",
    申请跟单提示文案7: "7.當跟隨的交易員訂單被判定為違規交易取消交易員身份時，您將無法跟隨開新的倉位，已跟隨的倉位不受影響，但會隨即脫離跟單模式。",
    申请跟单提示文案8: "8.交易員有權移除跟單用戶，被移除後，您將無法跟隨開新的倉位，已跟隨的倉位不受影響。",
    搜索您的国家名或国家区号: '搜索您的國家名或國家區號',
    我已同意成为交易员: '我已同意成爲交易員',
    请勾选: '請勾選',
    申请交易员失败提示: '您當前正在跟單中，暫不能申請成爲交易員，請停止全部跟單後再申請',
    我知道了: '我知道了',
    今日收益: '今日收益',
    累计收益: '累計收益',
    交易员分成: '交易員分成',
    待结算分成: '待結算分成',
    已结算分成: '已結算分成',
    当前跟单: '當前跟單',
    历史跟单: '歷史跟單',
    我的交易员: '我的交易員',
    编辑: '編輯',
    平仓均价: '平倉均價',
    持仓均价: '持倉均價',
    开仓时间: '開倉時間',
    平仓时间: '平倉時間',
    预估暴仓价: '預估暴倉價',
    交易员: '交易員',
    详情: '詳情',
    仓位ID: '倉位ID',
    空位提醒: '空位提醒',
    空位提醒内容: '該交易員帶單人數已滿，當交易員非滿員狀態時發送一次提醒',
    当前跟随: '當前跟隨',
    跟随人数数据: '{v1}/{v2}人',
    跟随人数: '跟隨人數',
    跟随中: '跟隨中',
    总权益: '總權益',
    带单合约: '帶單合約',
    交易数据: '交易數據',
    交易笔数: '交易筆數',
    盈利笔数: '盈利筆數',
    亏损笔数: '虧損筆數',
    扛单比例: '扛單比例',
    平均扛单率: '平均扛單率',
    最大扛单率: '最大扛單率',
    订单: '訂單',
    跟随者: '跟隨者',
    跟随者收益: '跟隨者收益',
    跟随用户: '跟隨用戶',
    跟随总额: '跟隨總額',
    跟随收益: '跟隨收益',
    交易员订单本金: '交易員訂單本金',
    当前带单: '當前帶單',
    历史带单: '歷史帶單',
    跟单数据统计: '跟單數據統計',
    不用了: '不用了',
    设置提醒成功: '設置提醒成功',
    我的带单: '我的帶單',
    查看主页: '查看主頁',
    利润分成比例: '利潤分成比例',
    跟随交易员: '跟隨交易員',
    仓位类型: '倉位類型',
    指定杠杆: '指定杠桿',
    请输入杠杆: '請輸入杠桿',
    单笔倍率: '單筆倍率',
    单笔金额: '單筆金額',
    固定额度: '固定金額',
    请输入单笔金额1: '請輸入不小於5U的固定金額',
    请输入单笔金额: '請輸入單筆跟單金額{v1}～{v2}',
    请输入单笔倍率: '請輸入跟單比例{v1}～{v2}',
    每次下单折合U: '每次開倉投入折合{v1}USDT的保證金',
    每次下单倍数: '每次下單數量是交易員下單數量的{v1}倍',
    倍率: '倍率',
    跟单本金: '跟單本金',
    总跟单保证金: '總跟單保證金',
    请输入跟单本金: '請輸入跟單本金',
    资产账户: '資產賬戶{v1}USDT',
    合约账户: '合約賬戶{v1}USDT',
    风险控制: '風險控製',
    设置: '設置',
    保存: '保存',
    取消跟随: '取消跟隨',
    移除跟随: '移除跟隨',
    交易员保证金: '交易員保證金',
    请输入交易员保证金: '請輸入交易員保證金',
    风险设置提示: '跟隨此交易員的持倉本金到達此數值後，將不再跟隨下單',
    关闭带单: '關閉帶單',
    我的跟随者: '我的跟隨者',
    带单设置: '帶單設置',
    预计利润分成: '預計利潤分成',
    利润分成: '利潤分成',
    开启成功: '開啓成功',
    开启失败: '開啓失敗',
    关闭成功: '關閉成功',
    关闭失败: '關閉失敗',
    确认取消吗: '確認取消跟隨嗎？',
    条件一: '合約無持倉、當前委託、計劃委託',
    条件二: '合約賬戶可用餘額>={v}USDT',
    条件三: '合約無持倉',
    最大回撤: '最大回撤',
    平均持仓时间: '平均持倉時間',
    正在跟随: '正在跟隨',
    历史跟随: '歷史跟隨',
    累计跟单: '累計跟單',
    累计分成: '累計分成',
    笔: '筆',
    上一页: '上一頁',
    下一页: '下一頁',
    返回: '返回',
    今日预估收益: '今日預估收益',
    账户权益: '賬戶權益',
    将账户权益展示在个人信息页面: '將賬戶權益展示在個人信息頁面',
    带单本金: '帶單本金',
    每次开仓均会展示带单本金: '每次開倉均會展示帶單本金',
    隐藏挂单价:'隱藏掛單價',
    带单币对: '帶單幣對',
    入住时间: '入住時間',
    保存成功: '保存成功',
    取消成功: '取消成功',
    设置成功: '設置成功',
    跟单合约: '跟單合約',
    历史委托: '歷史委托',
    成交数量: '成交數量',
    触发时间: '觸發時間',
    开启带单: '開啓帶單',
    账户已冻结: '賬戶已凍結,請聯系客服',
    审核中: '審核中',
    小时: '{v}小時',
    累计分润: '纍計分潤',
    今日预估分润: '今日預估分潤',
    交易协议: '《交易協議》',
    带单协议: '《帶單協議》',
    追加跟单本金: '追加跟單本金',
    提示: '提示：',
    提示信息: '分潤每日0點開始結算並在1點前完成，結算後將自動發放至您的合約帳戶； 如結算期間您有帶單持倉，將在下一個交易日結算分潤',
    合约跟单: '合約跟單',
    跟单文字: '在biking，與全球頂級交易員一起賺錢',
    查看牛人实盘: '查看牛人實盤',
    捕捉市场信号: '捕捉市場訊號',
    复制高手收益: '複製高手收益',
    跟单指南: '跟單指南',
    跟单广场: '跟單廣場',
    跟单总收益: '跟單總收益',
    丰厚分润收入: '豐厚分潤收入',
    更多平台曝光: '更多平臺曝光',
    专属交易徽章: '專屬交易徽章',
    成为Biking带单交易员: '僅需一步，成為Biking帶單交易員',
    享受Biking带单交易员的独家福利: '享受Biking帶單交易員的獨家福利',
    平台奖励: '享12%帶單分潤',
    联系方式: '聯繫方式',
    简介: '簡介',
    请输入简介: '請輸入簡介',
    交易能力证明: '交易能力證明（可選）',
    选择周期: '請選擇週期>30天的收益率曲線、交易資料統計等截圖； 若不上傳，我們將默認稽核您歐易交易記錄。 最多可上傳3張圖片，每張大小不超過10 MB。',
    我已阅读并同意: '我已閱讀並同意',
    跟单交易服务条款: '《跟單交易服務條款》',
    立即申请: '立即申請',
    请输入联系方式: '請輸入聯繫方式',
    联系方式不正确: '聯繫方式不正確!',
    邮箱格式不正确: '郵箱格式不正確',
    请输入简介信息: '請輸入簡介資訊',
    请确认勾选协议: '請確認勾選協定',
    上传头像图片限制: '上傳頭像圖片大小不能超過10MB!',
    最大限制: '當前最大限制上傳3個檔案',
    带单交易员招募中: '帶單交易員招募中，即刻尊享12%帶單分潤',
    跟单成功: '跟單成功',
    昵称: '暱稱',
    请输入昵称: '請輸入暱稱',
    申请交易员已提交: '申請交易員已提交，請等待審核'
  };
  export const hyy = {
    bkt: "不開通",
    wqdkt: "我確定開通",
    kt12: "1. 您在參與之前務必詳盡地了解數字貨幣合約交易的基本知識和相關風險以及參與衍生品交易所有關的業務規則等。",
    kt13: "2. 本風險提示書上述風險事項僅為列舉性質，未能詳盡的列明有關數字資產衍生品交易的所有風險因素，投資者參與數字資產衍生品交易投資前，還應該認真對其它可能存在風險因素有所了解和掌握。",
    kt14: "3. 我們誠摯的希望和建議投資者，從風險承受能力等自身實際情況出發，審慎的決定是否參與此合約交易，合理地配置自己的數字資產。",
    kt0: "親愛的用戶：",
    kt1: "您尚未開通合約賬戶及合約交易權限，請您仔細閱讀以下內容以後再決定是否開通：",
    kt2: "一、 您在合約市場進行交易，假如市場價格走勢對您不利導致您的倉位保證金不足時，幣贏永續合約會按照系統約定對您的倉位進行強平委託並披露強平明細。",
    kt3: "二、 您必須認真閱讀並遵守幣贏永續合約的業務規則，了解合約的機制和運行原理，了解市場的各種風險。",
    kt4: "四、 幣贏永續合約接入的是合約交易系統，用戶倉位的盈虧隨合約行情的波動而變化，當虧損較大時，亦會在合約交易系統中發生爆倉。請用戶您及時根據合約行情自行決定自己的交易行為，自負盈虧，據此，幣贏不承擔任何推定或者既定的保證責任。",
    kt5: "五	在某些極端的市場情況下，您可能會難以或無法將持有的未平倉合約平倉。例如，當你的盈利在整個合約市場中有效槓桿PnL中排位第一，且對手盤在保險基金不足以墊付其穿倉損失的情況下",
    kt6: "六、數字資產衍生品交易可能面臨一定法域內的政策監管風險，您在交易之前需在了解交易地域的政策監管背景的前提下審慎做出判斷。由於相關國家及地區法律、法規、政策的變化、合約交易所交易規則的修改、緊急措施的出台等原因，幣贏會提前披露聲明，您持有的未平倉合約可能無法繼續持有，但保證金和盈利的結餘仍會兌現",
    kt7: "七、	由於非平台方所能控制的原因，例如：地震、水災、火災等不可抗力因素或者計算機系統、通訊系統故障等，可能造成您的指令無法成交或者無法全部成交，由此導致的損失可能會由您自己承擔。",
    kt8: "八、	 “套期保值”交易同投机交易一样，同样面临价格波动引起的风险。",
    kta9: "九、	如果您沒有進行實名認證或者未綁定Google驗證，或者將賬號借給非本人操作，將可能會影響您的合約保證金的安全性。",
    kta10:
      "三、 在某些極端的市場情況下，您可能會難以或無法將持有的未平倉合約平倉。例如，當你的盈利在整個合約市場中有效槓桿PnL中排位第一，且對手盤在保險基金不足以墊付其穿倉損失的情況下。",

    kt9: "我已經仔細閱讀，並願意承擔風險",
    kt10: "開通合約賬號及合約交易權限",
    zjhz: "資金劃轉",
    ljhz: "立即劃轉",
    qx: "取消劃轉",
    khz: "可劃轉",
    qxz: "請選擇",
    bz: "幣種",
    c: "從",
    zz: "轉至",
    sl: "數量",
    qb: "全部",
    ktcg: "開通成功",
    ktsb: "開通失敗",
    hzcg: "劃轉成功",
    hzsb: "劃轉失敗",
    wyyd: "", //未勾选已经阅读提示文案
    tc: "退出",
    warning1: "請選擇幣種",
    warning2: "轉出賬戶不能為空",
    warning3: "轉入賬戶不能為空",
    warning4: "請輸入不大於可轉數量的數字",
    gb: "關閉",
    openSuccess: "您已開通合約交易",
    openSuccessTip: "請劃轉資金到合約帳戶",
    warning5: "最大保留4位小數",
    not_get_nm: "抱歉，泥碼活動已發放結束，本次劃轉未能獲得泥碼",
  }

  export const invite = {
    ljzc: '立即注册'
  }




// WEBPACK FOOTER //
// ./src/i18n/lang/merchandiser/tw.js